<template>
    <div class="article-what">
        <content-subheading heading="1. Tanker Cleaning" headingComponent="h2" marginBottom="mb-6" />
        <p>
            We offer professional cleaning services for tanks on ships, including oil tankers. Depending on the size and
            condition of the tank, our highly skilled team uses methods such as:
        </p>
        <ul>
            <li>Manual scraping to remove oil muck.</li>
            <li>
                Scaffolding and floating rafts for hard-to-reach areas. This process typically takes three days for
                manageable amounts of oil muck.
            </li>
        </ul>
        <content-subheading heading="2. De-slopping Before Dry Docking" headingComponent="h2" marginBottom="mb-6" />
        <p>
            Preparing ships for dry docking is essential. We safely remove oily water and other liquid waste from tanks,
            ensuring they are clean and ready for maintenance or repair work.
        </p>
        <content-subheading heading="3. Ship Pollutants Disposal" headingComponent="h2" marginBottom="mb-6" />
        <p>We specialise in the disposal of pollutants such as:</p>
        <ul>
            <li>Sludge</li>
            <li>Oily water</li>
            <li>Sewage</li>
        </ul>
        <p>
            By partnering with certified waste processing companies, we ensure that all pollutants are handled in a
            safe, environmentally friendly manner.
        </p>
        <content-subheading heading="4. SPRO Agreements" headingComponent="h2" marginBottom="mb-6" />
        <p>
            We work with shipowners to sign Ship Pollution Response Organisation (SPRO) agreements, ensuring their waste
            disposal needs comply with local regulations.
        </p>
        <content-subheading heading="5. Long-Term Partnerships" headingComponent="h2" marginBottom="mb-6" />
        <p>
            Our strong relationships with major shipping and ship management companies allow us to deliver consistent
            and reliable services to our clients.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleWhat',
};
</script>
